import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { PreviewContext } from '../preview.types';
import { getPagePreviewData } from '../preview-style.resolver';

@Component({
  selector: 'app-page-section-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-section-preview.html',
  styleUrl: './page-section-preview.scss',
})
export class PageSectionPreviewComponent {
  @Input() context: PreviewContext | null = null;
  @Input() viewMode: 'web' | 'mobile' = 'web';

  get data() {
    return getPagePreviewData(this.context);
  }
}
